import React, { useState } from "react";

import {
  Button,
  Container,
  Dropdown,
  DropdownItem,
  Grid,
  GridCol,
  Icon,
  Modal,
  Tooltip,
} from "../components";

import Base from "./utils/Base";

const Page = () => <h1 className="hello-world">Hello World!</h1>;

// const ModalExampleStatic = () => {
//   const [showModal, setShowModal] = useState(false);
//   return (
//     <>
//       <Button
//         data-a11y-dialog-show="default-modal"
//         onClick={() => setShowModal(true)}
//       >
//         Open Modal
//       </Button>
//       {/* {showModal && ( */}
//       <Modal id="default-modal" onHide={() => setShowModal(false)}>
//         <p className="no-mrg-bottom">text</p>
//       </Modal>
//       {/* )} */}
//     </>
//   );
// };

const ModalExampleReact = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button onClick={() => setShowModal(true)}>Open Modal</Button>
      {showModal && (
        <Modal id="default-modal" onHide={() => setShowModal(false)}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <p>
            lol
            <Tooltip dialog="LOL">
              <span className="no-mrg-bottom">text</span>
            </Tooltip>
            lol
          </p>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Modal>
      )}
    </>
  );
};

export default () => {
  return (
    <Base scope="react">
      <Container>
        <Grid>
          <GridCol>
            <Page />

            <Dropdown
              buttonProps={{
                children: "dropdowns",
              }}
              isOpen
            >
              <DropdownItem tag="button">Item 131345</DropdownItem>
              <DropdownItem tag="button">Item 1</DropdownItem>
              <DropdownItem tag="button">Item 1</DropdownItem>
            </Dropdown>

            <Button
              data-toggle={JSON.stringify([
                {
                  target: "#toggle-text-target",
                  attribute: "text",
                  value: "toggle on",
                },
                {
                  target: "#toggle-text-target",
                  attribute: "icon",
                  value: "/sprite.svg#home",
                },
              ])}
            >
              Toggle text and icon
            </Button>

            <p id="toggle-text-target">
              <Icon name="heart" />
              <span data-toggle-text-target>Toggle off</span>
            </p>
            <ModalExampleReact />
          </GridCol>
        </Grid>
      </Container>
    </Base>
  );
};
